const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, unknown>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const lang = match[1];
    const namespace = match[2];
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = {};
    }

    const nsExport = module[namespace] || module.default;
    if (nsExport && typeof nsExport === 'object') {
      messages[lang][namespace] = nsExport;
    }
  }
});

export default messages;